import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';
export default function CommentsSave(_ref) {
  let {
    attributes: {
      tagName: Tag
    }
  } = _ref;
  return createElement(Tag, useBlockProps.save(), createElement(InnerBlocks.Content, null));
}
//# sourceMappingURL=save.js.map